import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchData1 = (cases: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: cases,
});
export const fetchData2 = (accounts: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: accounts,
});


export const fetchCases = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,userid:uid};
            const apiname = DOCTOR_API.reportsdata_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAccountDetails = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,userid:uid};
            const apiname = DOCTOR_API.reportsdata_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

